// extracted by mini-css-extract-plugin
export var alert = "index-module--alert--af406";
export var alert__failure = "index-module--alert__failure--c7bcc";
export var alert__info = "index-module--alert__info--cfa0f";
export var alert__success = "index-module--alert__success--14443";
export var alert__warning = "index-module--alert__warning--5ba8e";